/**
 * Scan token constants for RapID (6-char) and RFID (8-char) tags.
 */
export const RAPID_TAG_LENGTH = 6;
export const RFID_TAG_LENGTH = 8;
export const SCAN_TOKEN_MAX_LENGTH = 32;
const RAPID_TAG_PATTERN = /^[A-Z0-9]{6}$/;
const RFID_TAG_PATTERN = /^[A-Z0-9]{8}$/;
const TEMPERATURE_SUFFIX_PATTERN = /^[+-]?\d+(\.\d+)?C$/;
export function normalizeScanToken(token) {
    const normalized = token.trim().toUpperCase();
    if (!normalized) {
        return null;
    }
    const [scanToken, temperatureSuffix, ...extraTokens] = normalized.split(',');
    const normalizedScanToken = scanToken?.trim();
    const normalizedTemperatureSuffix = temperatureSuffix?.trim();
    if (normalizedScanToken === undefined) {
        return null;
    }
    if (extraTokens.length > 0) {
        return null;
    }
    if (normalizedTemperatureSuffix === undefined) {
        return RAPID_TAG_PATTERN.test(normalizedScanToken) || RFID_TAG_PATTERN.test(normalizedScanToken)
            ? normalizedScanToken
            : null;
    }
    if (!RFID_TAG_PATTERN.test(normalizedScanToken)) {
        return null;
    }
    return TEMPERATURE_SUFFIX_PATTERN.test(normalizedTemperatureSuffix) ? normalizedScanToken : null;
}
export function isValidScanToken(token) {
    return normalizeScanToken(token) !== null;
}
export function shouldShowScanTokenError(token) {
    const normalized = token.trim().toUpperCase();
    if (!normalized || isValidScanToken(normalized)) {
        return false;
    }
    if (normalized.includes(',')) {
        const [scanToken, temperatureSuffix, ...extraTokens] = normalized.split(',');
        return (scanToken !== undefined &&
            scanToken.length >= RFID_TAG_LENGTH &&
            (temperatureSuffix !== undefined || extraTokens.length > 0));
    }
    return normalized.length >= RAPID_TAG_LENGTH;
}
export const SCAN_TOKEN_ERROR_MESSAGE = 'Invalid scan format. Must be exactly 6 (RapID) or 8 (RFID) alphanumeric characters. RFID scans may include a trailing temperature like ,23.1C.';
//# sourceMappingURL=scan-token.constants.js.map